import { Outlet, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { useEffect } from 'react';
import AppToast from '../components/common/Toast';
import AssessmentNotification from '../components/main/acra/AssessmentNotification';
import { useAppSelector } from '../hooks/redux-hooks';
import { setSessionIdHeader } from '../utils/set-token';

const MainLayout = () => {
  const navigate = useNavigate();
  const { toastInfo, sessionId } = useAppSelector(state => state.common);

  useEffect(() => {
    const persistedSessionId = localStorage.getItem('sessionId') || '';
    const activeSessionId = sessionId || persistedSessionId;

    if (!activeSessionId) {
      navigate('/');
      return;
    }

    setSessionIdHeader(activeSessionId);
  }, [navigate, sessionId]);

  return (
    <div className="flex h-[100vh] w-[100vw] overflow-hidden py-2 pl-[50px] bg-[#fafafa]">
      <Navbar />
      <div className="grow flex overflow-auto relative z-[1]">
        <Outlet />
      </div>
      {toastInfo?.isOpen && <AppToast />}
      {/* Floats over every page while a campaign assessment is generating. */}
      <AssessmentNotification />
    </div>
  );
};

export default MainLayout;
